module.exports = __webpack_public_path__ + "static/blog-img3-2714ef30568135d03f876dea94970f1f.jpg";